<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.92 12.3819C17.8724 12.5046 17.801 12.6168 17.71 12.7119L12.71 17.7119C12.6168 17.8051 12.5061 17.8791 12.3842 17.9295C12.2624 17.98 12.1319 18.006 12 18.006C11.7337 18.006 11.4783 17.9002 11.29 17.7119C11.1968 17.6186 11.1228 17.5079 11.0723 17.3861C11.0219 17.2643 10.9959 17.1337 10.9959 17.0019C10.9959 16.7356 11.1017 16.4802 11.29 16.2919L14.59 13.0019H7C6.73478 13.0019 6.48043 12.8965 6.29289 12.709C6.10536 12.5214 6 12.2671 6 12.0019C6 11.7367 6.10536 11.4823 6.29289 11.2948C6.48043 11.1072 6.73478 11.0019 7 11.0019H14.59L11.29 7.71189C11.1963 7.61892 11.1219 7.50832 11.0711 7.38646C11.0203 7.26461 10.9942 7.1339 10.9942 7.00189C10.9942 6.86988 11.0203 6.73917 11.0711 6.61731C11.1219 6.49545 11.1963 6.38485 11.29 6.29189C11.383 6.19816 11.4936 6.12376 11.6154 6.073C11.7373 6.02223 11.868 5.99609 12 5.99609C12.132 5.99609 12.2627 6.02223 12.3846 6.073C12.5064 6.12376 12.617 6.19816 12.71 6.29189L17.71 11.2919C17.801 11.387 17.8724 11.4991 17.92 11.6219C18.02 11.8653 18.02 12.1384 17.92 12.3819Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'NextIcon',
};
</script>
